import React from 'react';
import { Logo } from './Logo';
import { PAGE_ROUTE } from '../../lib/routes';
interface TeasingShellProps {
  navigate: (page: string) => void;
  children: React.ReactNode;
}
export function TeasingShell({
  navigate,
  children
}: TeasingShellProps) {
  return <div className="min-h-screen bg-dark-1 text-foreground font-sans flex flex-col relative" data-id="element-2254">
      {/* Minimal Header */}
      <header className="w-full h-20 border-b border-dark-4 bg-dark-1/80 backdrop-blur-md sticky top-0 z-40 flex items-center justify-center px-4" data-id="element-2255">
        <Logo onClick={() => navigate(PAGE_ROUTE.HOME)} data-id="element-2256" />
      </header>

      <main className="flex-1 flex flex-col" data-id="element-2257">{children}</main>

      {/* Minimal Footer */}
      <footer className="w-full border-t border-dark-4 bg-dark-1 py-8 mt-auto" data-id="element-2258">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-2259">
          <div className="flex items-center gap-6 text-sm text-light-3" data-id="element-2260">
            <button onClick={() => navigate(PAGE_ROUTE.TERMENI)} className="hover:text-light-1 transition-colors" data-id="element-2261">
              Termeni
            </button>
            <button onClick={() => navigate(PAGE_ROUTE.CONFIDENTIALITATE)} className="hover:text-light-1 transition-colors" data-id="element-2262">
              Confidențialitate
            </button>
            <button onClick={() => navigate(PAGE_ROUTE.CONTACT)} className="hover:text-light-1 transition-colors" data-id="element-2263">
              Contact
            </button>
          </div>
          <p className="text-sm text-light-3" data-id="element-2264">
            © {new Date().getFullYear()} Izio. Toate drepturile rezervate.
          </p>
        </div>
      </footer>
    </div>;
}